<template>
  <div id="pers-tab2-6" name="hrms32e-tab2-tab6" class="content-pers">

    <div class="col-xs-12 col-md-6 pull-left">  
      <div class="col-xs-12 card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic1">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRMS32EC16']['20'] }}</div>
        </div>

        <div class="data-box clearfix" v-show="subTopic1">
          <template v-for="(value, index) in detail.table1.rows">
            <div class="table-row clearfix">
              <div class="col-xs-12 body-table-left color-skin">{{ value.coddeduct }} - {{ value.desdeduct }}</div>
              <div class="col-xs-12 body-table-right">
                <div class="data-table-row">
                  <div class="col-xs-5 table-label">{{ labels['HRMS32EC16']['50'] }}</div>
                  <div class="col-xs-7 table-input">
                    <div class="input-group">
                      <input type="text" class="form-control input-text" 
                             v-model="value.amtdeduct" 
                             maxlength="12"
                             v-validate="'decimal:2|max:12'"
                             :data-vv-name="'amtdeduct-1-' + index"
                             :has-error="errors.has('amtdeduct-1-' + index)" />
                      <span class="input-group-addon input-group-addon-cust">{{ constLabels[nowLang]['bath'] }}</span>
                    </div>
                    <div class="text-error" v-show="errors.has('amtdeduct-1-' + index)">{{errors.first('amtdeduct-1-' + index)}}</div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 body-table-right">
                <div class="data-table-row">
                  <div class="col-xs-5 table-label">{{ labels['HRMS32EC16']['50'] }} ({{ constLabels[nowLang]['spouse'] }})</div>
                  <div class="col-xs-7 table-input">
                    <div class="input-group">
                      <input type="text" class="form-control input-text" 
                             v-model="value.amtdeduct_spous" 
                             maxlength="12"
                             v-validate="'decimal:2|max:12'"
                             :data-vv-name="'amtdeduct_spous-1-' + index"
                             :has-error="errors.has('amtdeduct_spous-1-' + index)" />
                      <span class="input-group-addon input-group-addon-cust">{{ constLabels[nowLang]['bath'] }}</span>
                    </div>
                    <div class="text-error" v-show="errors.has('amtdeduct_spous-1-' + index)">{{errors.first('amtdeduct_spous-1-' + index)}}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div> 
      </div>
    </div>

    <div class="col-xs-12 col-md-6 pull-right">  
      <div class="col-xs-12 card-ui card-ui-right clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic2">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRMS32EC16']['100'] }}</div>
        </div>

        <div class="data-box clearfix" v-show="subTopic2">
          <template v-for="(value, index) in detail.table2.rows">
            <div class="table-row clearfix">
              <div class="col-xs-12 body-table-left color-skin">{{ value.coddeduct }} - {{ value.desdeduct }}</div>
              <div class="col-xs-12 body-table-right">
                <div class="data-table-row">
                  <div class="col-xs-5 table-label">{{ labels['HRMS32EC16']['50'] }}</div>
                  <div class="col-xs-7 table-input">
                    <div class="input-group">
                      <input type="text" class="form-control input-text" 
                             v-model="value.amtdeduct" 
                             maxlength="12"
                             v-validate="'decimal:2|max:12'"
                             :data-vv-name="'amtdeduct-2-' + index"
                             :has-error="errors.has('amtdeduct-2-' + index)" />
                      <span class="input-group-addon input-group-addon-cust">{{ constLabels[nowLang]['bath'] }}</span>
                    </div>
                    <div class="text-error" v-show="errors.has('amtdeduct-2-' + index)">{{errors.first('amtdeduct-2-' + index)}}</div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 body-table-right">
                <div class="data-table-row">
                  <div class="col-xs-5 table-label">{{ labels['HRMS32EC16']['50'] }} ({{ constLabels[nowLang]['spouse'] }})</div>
                  <div class="col-xs-7 table-input">
                    <div class="input-group">
                      <input type="text" class="form-control input-text" 
                             v-model="value.amtdeduct_spous" 
                             maxlength="12"
                             v-validate="'decimal:2|max:12'"
                             :data-vv-name="'amtdeduct_spous-2-' + index"
                             :has-error="errors.has('amtdeduct_spous-2-' + index)" />
                      <span class="input-group-addon input-group-addon-cust">{{ constLabels[nowLang]['bath'] }}</span>
                    </div>
                    <div class="text-error" v-show="errors.has('amtdeduct_spous-2-' + index)">{{errors.first('amtdeduct_spous-2-' + index)}}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div> 
      </div>
    </div>

    <div class="col-xs-12 col-md-6 pull-left">  
      <div class="col-xs-12 card-ui clearfix border-top-color-skin">
        <div class="sub-topic-box clearfix" @click="toggleSubTopic3">
          <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
          <div class="sub-topic">{{ labels['HRMS32EC16']['140'] }}</div>
        </div>

        <div class="data-box clearfix" v-show="subTopic3">
          <template v-for="(value, index) in detail.table3.rows">
            <div class="table-row clearfix">
              <div class="col-xs-12 body-table-left color-skin">{{ value.coddeduct }} - {{ value.desdeduct }}</div>
              <div class="col-xs-12 body-table-right">
                <div class="data-table-row">
                  <div class="col-xs-5 table-label">{{ labels['HRMS32EC16']['50'] }}</div>
                  <div class="col-xs-7 table-input">
                    <div class="input-group">
                      <input type="text" class="form-control input-text" 
                             v-model="value.amtdeduct" 
                             maxlength="12"
                             v-validate="'decimal:2|max:12'"
                             :data-vv-name="'amtdeduct-3-' + index"
                             :has-error="errors.has('amtdeduct-3-' + index)" />
                      <span class="input-group-addon input-group-addon-cust">{{ constLabels[nowLang]['bath'] }}</span>
                    </div>
                    <div class="text-error" v-show="errors.has('amtdeduct-3-' + index)">{{errors.first('amtdeduct-3-' + index)}}</div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 body-table-right">
                <div class="data-table-row">
                  <div class="col-xs-5 table-label">{{ labels['HRMS32EC16']['50'] }} ({{ constLabels[nowLang]['spouse'] }})</div>
                  <div class="col-xs-7 table-input">
                    <div class="input-group">
                      <input type="text" class="form-control input-text" 
                             v-model="value.amtdeduct_spous" 
                             maxlength="12"
                             v-validate="'decimal:2|max:12'"
                             :data-vv-name="'amtdeduct_spous-3-' + index"
                             :has-error="errors.has('amtdeduct_spous-3-' + index)" />
                      <span class="input-group-addon input-group-addon-cust">{{ constLabels[nowLang]['bath'] }}</span>
                    </div>
                    <div class="text-error" v-show="errors.has('amtdeduct_spous-3-' + index)">{{errors.first('amtdeduct_spous-3-' + index)}}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div> 
      </div>
    </div>

    <div class="col-md-12 box-footer">
      <button type="button" class="btn bg-dark-gray pull-left" @click="togglePage(0)" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
      <button type="button" class="btn bg-color-skin" @click="callSave()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
    </div>

  </div>
</template>

<script>
export default {
  name: 'hrms32e-tab2-tab6',
  data () {
    return {
      subTopic1: true,
      subTopic2: true,
      subTopic3: true,
      constLabels: {
        en: {
          spouse: 'spouse',
          bath: 'bath'
        },
        th: {
          spouse: 'คู่สมรส',
          bath: 'บาท'
        }
      }
    }
  },
  watch: {
    detail () {
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  methods: {
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    },
    toggleSubTopic2 () {
      this.subTopic2 = !this.subTopic2
    },
    toggleSubTopic3 () {
      this.subTopic3 = !this.subTopic3
    },
    saveParams () {
      return {
        p_codempid: this.indexSelected.codempid,
        p_dtereq: this.searchDetail.dtereq,
        p_numseq: this.indexSelected.numseq,
        p_codempid_query: this.searchDetail.codempid_query,
        table1: this.detail.table1.rows,
        table2: this.detail.table2.rows,
        table3: this.detail.table3.rows
      }
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result && this.searchDetail.codempid_query !== '') {
          this.postDetail2Tab6Save({ saveParams: this.saveParams(), searchIndex: this.searchIndex, togglePage: this.togglePage })
        }
      })
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'toggleSubPage', 'triggerSubButton', 'labelsButton', 'postDetail2Tab6Save', 'indexSelected', 'searchDetail', 'searchIndex', 'validateStaappr' ]
}

</script>


// WEBPACK FOOTER //
// tab2_6.vue?1b469ab8